import "core-js/modules/es.array.concat.js";
import React from 'react';
import moment from 'moment';
import { Box, IconTooltip } from '@applyboard/ui-components';
import { CheckMarkOutlineIcon, CloseOutlineIcon, WarningFillIcon } from '@applyboard/ui-icons';
import { capitalize } from '@applyboard/ui-utils';
// eslint-disable-line @typescript-eslint/no-unused-vars
import Table from "../../Table";
function ValidatedField(props) {
  var ICONS = {
    negative: CloseOutlineIcon,
    positive: CheckMarkOutlineIcon,
    warning: WarningFillIcon
  };
  var field = props.field,
    intent = props.intent,
    label = props.label,
    title = props.title;
  var ValidationIcon = ICONS[intent];
  return /*#__PURE__*/React.createElement(Box, null, field, intent && ValidationIcon && /*#__PURE__*/React.createElement(IconTooltip, {
    "aria-label": label,
    icon: /*#__PURE__*/React.createElement(ValidationIcon, {
      intent: intent
    }),
    title: /*#__PURE__*/React.createElement("span", null, title)
  }));
}
function getEmailValidationIntent(isEmailValidated) {
  switch (isEmailValidated) {
    case undefined:
      return 'warning';
    case true:
      return 'positive';
    case false:
      return 'negative';
    default:
      return null;
  }
}
var getBirthdayText = function getBirthdayText(birthday) {
  return moment(birthday).isValid() ? "".concat(birthday, " (").concat(moment().diff(birthday, 'years'), " years old)") : null;
};
var StudentContent = function StudentContent(props) {
  var _info$email_validatio, _info$email_validatio2;
  var EMAIL_ICON_TITLE = {
    negative: 'Email is invalid',
    positive: 'Email is valid',
    warning: 'Email has not yet been validated'
  };
  var GENERIC_VERIFICATION_TITLE = 'This field has been verified by a document on this application';
  var info = props.info,
    showLoginEmailValidation = props.showLoginEmailValidation,
    showPrimaryEmailValidation = props.showPrimaryEmailValidation;
  var studentTableInfo = [{
    name: 'First Name',
    value: /*#__PURE__*/React.createElement(ValidatedField, {
      field: capitalize(info.first_name),
      intent: info.first_name_verified_at ? 'positive' : null,
      label: "First Name Verified",
      title: GENERIC_VERIFICATION_TITLE
    })
  }, {
    name: 'Last Name',
    value: /*#__PURE__*/React.createElement(ValidatedField, {
      field: capitalize(info.last_name),
      intent: info.last_name_verified_at ? 'positive' : null,
      label: "Last Name Verified",
      title: GENERIC_VERIFICATION_TITLE
    })
  }, {
    name: 'Birthday',
    value: /*#__PURE__*/React.createElement(ValidatedField, {
      field: getBirthdayText(info.birthday),
      intent: info.birthdate_verified_at ? 'positive' : null,
      label: "Birthday Verified",
      title: GENERIC_VERIFICATION_TITLE
    })
  }, {
    name: 'Phone Number',
    value: info.phone
  }, {
    name: 'First Language',
    value: info.first_language
  }, {
    name: 'Gender',
    value: /*#__PURE__*/React.createElement(ValidatedField, {
      field: info.gender,
      intent: info.gender_verified_at ? 'positive' : null,
      label: "Gender Verified",
      title: GENERIC_VERIFICATION_TITLE
    })
  }, {
    name: 'Marital Status',
    value: capitalize(info.marital_status)
  }, {
    name: 'Passport Number',
    value: /*#__PURE__*/React.createElement(ValidatedField, {
      field: info.passport_number,
      intent: info.passport_number_verified_at ? 'positive' : null,
      label: "Passport Number Verified",
      title: GENERIC_VERIFICATION_TITLE
    })
  }, {
    name: 'Passport Expiry Date',
    value: /*#__PURE__*/React.createElement(ValidatedField, {
      field: info.passportExpiryDay,
      intent: info.passport_expiry_date_verified_at ? 'positive' : null,
      label: "Passport Expiry Date Verified",
      title: GENERIC_VERIFICATION_TITLE
    })
  }];
  if (info.primary_email) {
    var _info$primary_email_v, _info$primary_email_v2;
    studentTableInfo.unshift({
      name: 'Primary Email',
      value: /*#__PURE__*/React.createElement(ValidatedField, {
        field: info.primary_email,
        intent: getEmailValidationIntent(showPrimaryEmailValidation ? (_info$primary_email_v = info.primary_email_validation) === null || _info$primary_email_v === void 0 ? void 0 : _info$primary_email_v.is_valid : null),
        label: "Primary Email Validation",
        title: EMAIL_ICON_TITLE[getEmailValidationIntent(showPrimaryEmailValidation ? (_info$primary_email_v2 = info.primary_email_validation) === null || _info$primary_email_v2 === void 0 ? void 0 : _info$primary_email_v2.is_valid : null)]
      })
    });
  }
  studentTableInfo.unshift({
    name: 'Login Email',
    value: /*#__PURE__*/React.createElement(ValidatedField, {
      field: info.email,
      intent: getEmailValidationIntent(showLoginEmailValidation ? (_info$email_validatio = info.email_validation) === null || _info$email_validatio === void 0 ? void 0 : _info$email_validatio.is_valid : null),
      label: "Login Email Validation",
      title: EMAIL_ICON_TITLE[getEmailValidationIntent(showLoginEmailValidation ? (_info$email_validatio2 = info.email_validation) === null || _info$email_validatio2 === void 0 ? void 0 : _info$email_validatio2.is_valid : null)]
    })
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    info: studentTableInfo
  }));
};
export default StudentContent;